import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { fetchGroupingUser } from './groupingUserActions';
import { BASE_S3 } from 'config/consts';

function GroupingUserImage({userId, divider, maxHeight, data, fetchGroupingUser}) {
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    if (userId) {
      fetchGroupingUser(userId);
    }
  }, [fetchGroupingUser, userId]);

  const { logo_image, name } = data || {};

  const handleImageLoad = () => {
    setIsLoaded(true);
  };

  console.log('IMG: Agrupamento: LOGs', logo_image, name );

  return (
    <>
      {logo_image && (
        <> {
            divider && (
              <hr style={{
                height: 24,
                borderLeft: '1px solid #bdbcbc',
                marginRight: 16,
                marginLeft: 16,
              }}
            />
            )
           }
          <img
            src={`${BASE_S3}/${logo_image}`}
            style={{
              height: maxHeight || 44,
              maxWidth: 120,
              borderRadius: 4,
              opacity: isLoaded ? 1 : 0,
              transition: 'opacity 0.5s ease-in-out',
            }}
            className="img-fluid"
            alt={`Imagem do grupo: ${name}`}
            onLoad={handleImageLoad}
          />
        </>
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  loading: state.groupingUser?.loading,
  data: state.groupingUser?.data,
  error: state.groupingUser?.error,
});

const mapDispatchToProps = {
  fetchGroupingUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(GroupingUserImage);
